import { v } from '../validation'

// Define the schema for the COIS wizard steps
// exported here for reuse in multiple places, and to enable changing the validation library in the future
export const coisPartyDetailsSchema = v.object({
  emailAddress: v.string().email().label('Email')
})
